import { dataArrowDown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowDown = /*#__PURE__*/createIcon(dataArrowDown)
export default IconArrowDown
